import React from 'react';
import { App, Button } from 'antd';
import { FormattedMessage } from 'react-intl';

const CloseButton = () => {
  const { notification } = App.useApp();

  return (
    <Button type="text" className="acast-message__close-button" onClick={notification.destroy}>
      <FormattedMessage defaultMessage="Close" />
    </Button>
  );
};

export default CloseButton;
